<div class="content">
  <div class="step-container">
    <div class="step-title">
      <div>
        <span class="step-title-text">{{ stepTitle | translate }}</span>
      </div>
      <div class="step-content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
